import { useCallback } from 'react';

import type { Cart } from 'restful/tickets';
import { beginCheckout } from 'services/avo';
import { useTrackEvent } from 'services/datalayer/hooks';

import { useEventBundle } from './useEventBundle';
import { mapCartToDatalayer } from './utils';

export const useTrackBeginCheckout = () => {
  const eventBundle = useEventBundle();

  const track = useTrackEvent({
    trackFn: beginCheckout,
    variables: eventBundle,
  });

  return useCallback(
    (cart: Cart) => {
      track(mapCartToDatalayer(cart, eventBundle));
    },
    [eventBundle, track],
  );
};
